import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useLatestInvoice } from "@circle-react/hooks/account_payment_processor/useLatestInvoice";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";
import { Banner } from "@circleco/compass/components/Banner";

import { t } from "@/i18n-js/instance";
import { useTrialBanner } from "@/react/components/Layout/TrialBanner/useTrialBanner";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { useBillingContext } from "@/react/components/SettingsApp/Plan/PlanDetails/NewBillingDetails/BillingContext";

import { WarningWrapper } from "./WarningWrapper";

export const SubscriptionWithIncompletePayment = () => {
  const { currentCommunity } = usePunditUserContext();
  const { isCurrentPlanPlus } = useBillingContext();
  const { isSubscriptionCancelled } = useTrialBanner();
  const { isLoadingInvoice, onRetrieveLatestInvoice, latestInvoice } =
    useLatestInvoice();
  const { isCircleV4 } = useCircleV4();

  if (currentCommunity && isCurrentPlanPlus && isSubscriptionCancelled) {
    return null;
  }

  if (latestInvoice?.hosted_invoice_url) {
    window.location.replace(latestInvoice.hosted_invoice_url);
  }

  if (isCircleV4) {
    return (
      <>
        {isLoadingInvoice && <Loader variant="fullscreen" />}
        <Banner
          variant="warning"
          icon="triangle-exclamation"
          iconColor="warning"
          title={t("subscription.incomplete_reactified.title")}
          description={t("subscription.incomplete_reactified.description")}
          actionProps={{
            variant: "outline",
            children: t("subscription.incomplete_reactified.action"),
            disabled: isLoadingInvoice,
            onClick: onRetrieveLatestInvoice,
          }}
        />
      </>
    );
  }

  return (
    <WarningWrapper>
      {isLoadingInvoice && <Loader variant="fullscreen" />}
      <Typography.LabelLg weight="semibold">
        {t("subscription.incomplete_reactified.title")}
      </Typography.LabelLg>
      <Typography.BodyMd color="text-default">
        {t("subscription.incomplete_reactified.description")}
      </Typography.BodyMd>
      <div className="mt-2 inline-block">
        <Button
          variant="secondary"
          disabled={isLoadingInvoice}
          onClick={onRetrieveLatestInvoice}
        >
          {t("subscription.incomplete_reactified.action")}
        </Button>
      </div>
    </WarningWrapper>
  );
};
